export function checkSrc(src: string, section?: string) {
  let host: string;
  try {
    host = new URL(src).host;
  } catch {
    console.error(`Invalid URL: ${src} in ${section}`);
    return false;
  }
  const allowedHosts = ['ctfassets.net', 'squarecdn.com', 'campaign-hub-production-f.squarecdn.com'];
  const isInternal = allowedHosts.some((allowedHost) => host === allowedHost || host.endsWith(`.${allowedHost}`));
  if (!isInternal) {
    console.error(
      `${src} in ${section} must be hosted on our .ctfassets.net instance or .squarecdn.com domain or our s3 bucket`
    );
  }
  return isInternal;
}
